import { Company } from '../types/career'

const COMPANIES: Company[] = [
	{
		title: 'Фриланс',
		dateUp: 1561921200,
		dateDown: 1593457200,
		jobTitle: 'Фронтенд-разработчик',
		description: [
			'Разработал информационный портал для образовательного учреждения с системой управления контентом, что обеспечило удобную публикацию и обновление материалов редакторами.',
			'Создавал адаптивные лендинги и интернет-магазины с интеграцией платежных систем, обеспечивая корректную работу пользовательских сценариев на разных устройствах.',
		],
	},
	{
		title: 'UNIT6',
		link: 'https://www.unit6.dev/',
		dateUp: 1593543600,
		dateDown: 1629658800,
		jobTitle: 'Младший фронтенд-разработчик',
		description: [
			'Разрабатывал личные кабинеты с функционалом управления данными и настройками пользователя, улучшая удобство повседневной работы пользователей с сервисом.',
			'Создавал промо-сайты и лендинги с анимациями и интерактивными элементами, повышая вовлеченность пользователей и качество визуальной коммуникации продукта.',
		],
	},
	{
		title: 'Сайтсофт',
		link: 'https://sitesoft.ru/',
		dateUp: 1629745200,
		dateDown: 1682899200,
		jobTitle: 'Фронтенд-разработчик',
		description: [
			'Отвечал за поддержку и модернизацию более 30 проектов различной сложности для крупных клиентов, обеспечивая стабильность релизов и эволюционное развитие frontend-части.',
			'Спроектировал и внедрил систему переиспользуемых компонентов и шаблонов, что сократило время запуска новых проектов на 40%.',
			'Разработал внутренние библиотеки компонентов и утилит, стандартизировал подходы к frontend-разработке и повысил переиспользуемость решений в команде.',
			'Проводил системный рефакторинг legacy-кода и сокращал технический долг, повышая производительность клиентской части и упрощая дальнейшее развитие проектов.',
			'Организовал процесс интернационализации проектов: внедрил единый подход к локализации интерфейсов и контента, что упростило масштабирование на новые языки и снизило количество ошибок при релизах.',
		],
	},
	{
		title: 'СБЕРБАНК',
		link: 'https://www.sberbank.ru/ru/person',
		dateUp: 1682899200,
		isNowJob: true,
		jobTitle: 'Старший фронтенд-разработчик',
		description: [
			'Вывел в продакшен 3 frontend-решения с нуля (AI-чат, информационный сниппет/тикер и модуль подключения партнеров): от пустой директории до промышленной эксплуатации по банковским стандартам безопасности.',
			'Проектировал архитектуру frontend-решений и координировал взаимодействие с backend-командой по API-контрактам, обеспечивая техническую целостность решений и предсказуемую поставку функциональности.',
			'Участвовал в выстраивании процесса релизов frontend-продуктов в продакшен, реализовал интеграции с внутренними и внешними сервисами и автоматизировал ключевые проверки, что снизило риски регрессий и объем ручных операций.',
			'Реализовал асинхронную обработку и поэтапную загрузку данных в клиентских приложениях, что повысило отзывчивость интерфейсов под высокой нагрузкой и улучшило пользовательский опыт при работе с большими объемами данных.',
			'Отвечал за frontend-реализацию AI-чата: разработал UI, интегрировал API и обеспечил стабильную работу клиентской части в тесной связке с backend, аналитикой и поддержкой; в результате среднее время ответа сократилось с 4 часов до 10 минут.',
			'Разработал информационный тикер для клиентских интерфейсов с гибкой конфигурацией комиссий и тарифных параметров, что повысило прозрачность условий для пользователей и упростило сопровождение изменений продуктовой командой.',
			'Разработал модуль подключения новых партнеров, который использовали смежные команды (безопасность, КАМ и другие сотрудники); обеспечил межкомандные интеграции и внедрил SAST/OSS-проверки в каждый pull request в соответствии со стандартами безопасности банка.',
		],
	},
]

export { COMPANIES }
